export type SearchType = 'orderNumber' | 'orderRef' | 'orderItemRef' | 'customerNumber' | 'customerName' | 'street' | 'suburb' | 'consignmentNumber' | 'tripNumber' | 'description'

export const SearchTypeEnum: Record<SearchType, string> = {
  orderNumber: 'Order Number',
  orderRef: 'Order Ref',
  orderItemRef: 'Order Item Ref',
  customerNumber: 'Customer Number',
  customerName: 'Customer Name',
  street: 'Street',
  suburb: 'Suburb',
  consignmentNumber: 'Consignment Number',
  tripNumber: 'Trip Number',
  description: 'Description',
}

export const AllSearchTypes = Object.keys(SearchTypeEnum) as SearchType[]